module.exports = __webpack_public_path__ + "img/logo-presse-alloweb_200x200.bee8c516.jpg";